export default __webpack_public_path__ + "static/media/Group 10378.e2314fdb.svg";